import { createFileRoute } from "@tanstack/react-router";

import { fetchPoliciesRescheduling } from "@/loaders/policies";
import Policies from "@/pages/policies";

export const Route = createFileRoute(
  "/policies/$company/$location/rescheduling"
)({
  component: ReschedulingPage,
  head: ({ loaderData }) => {
    if (!loaderData) {
      return {};
    }
    return { meta: [{ title: loaderData.title }] };
  },
  loader: ({ params }) =>
    fetchPoliciesRescheduling({
      data: { company: params.company, location: params.location },
    }),
});

function ReschedulingPage() {
  const data = Route.useLoaderData();
  return <Policies {...data} />;
}
